<template>
    <div>
        <audit
            v-if="auditSelected"
            :audit="auditSelected"
            reviewer="true"
            v-on:reloadAudit=reloadAudit
            >
        </audit>
    </div>
</template>

<script>
    import Audit from '@/components/Audit.vue'
    import { mapState } from 'vuex'


    export default {
        data() {
            return {

            }
        },
        computed: mapState({
            auditSelected: state => state.currentAudit.header
        }),
        components: {
            'audit': Audit
        },
        methods: {
            loadAudit() {
                let auditSelected = this.auditSelected
                let auditId = this.$route.params.auditId
                if (!auditSelected || auditSelected.id != auditId) {
                    this.$store.dispatch('currentAudit/setCurrent', { id: auditId })
                }
            },
            reloadAudit() {
                let audit = this.auditSelected
                if (!audit) {
                    audit = { id: this.$route.params.auditId }
                }
                console.log("reloading audit", audit)
                if (audit) {
                    this.$store.dispatch('currentAudit/setCurrent', audit)
                }
            }
        },
        watch: {
            $route: 'loadAudit'
        },
        created() {
            this.loadAudit()
        }
    }
</script>
